import React from "react";
import HighQ from "react-icons/lib/md/high-quality";
import Car from "react-icons/lib/md/drive-eta";

function MoreDetails(){
    return(
        <div className="more-details-cnt">
            <div className="more-details">
                <div className="details">
                    <div className="text cairo-font">
                        <div className="icon">
                            <HighQ/>
                        </div>
                        <h1>خبرة على أعلى مستوى</h1>
                        <p>يوفر لك مركز المهندس خبراء على اعلى مستوى  <br/>خبرة أكثر من 20 عام </p>
                    </div>
                    <div className="images">
                        <img src="https://mhesham32cdn.netlify.com/img/elmohandess/center1.jpg" alt=""/>
                        <img src="https://mhesham32cdn.netlify.com/img/elmohandess/center3.jpg" alt=""/>
                    </div>
                </div>
                <div className="details">
                    <div className="text cairo-font">
                        <div className="icon">
                            <Car/>
                        </div>
                        <h1>سيارتك فى أمان</h1>
                        <p>مع المهندس سيارتك فى أمان لتوافر عمال ذوى خبرة وأجهزة متطورة</p>
                    </div>
                    <div className="images">
                        <img src="https://mhesham32cdn.netlify.com/img/elmohandess/center2.jpg" alt=""/>
                        <img src="https://mhesham32cdn.netlify.com/img/elmohandess/center4.jpg" alt=""/>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default MoreDetails;


// WEBPACK FOOTER //
// ./src/components/about/MoreDetails.js